import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/pages/admin/AdminLayout";
import Settings from "@/pages/admin/Settings";
import { buildSeoHead, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/admin/settings")({
  head: () =>
    buildSeoHead(
      { ...publicPageSeo.home, key: "admin-settings", path: "/admin/settings", title: "Cloud Admin Settings", description: "Administrationsyta" },
      [],
      { noindex: true },
    ),
  component: () => <AdminLayout><Settings /></AdminLayout>,
});
